export const environment = {
  production: false,
  appUrl: 'https://shlonak.exist.com.ph',
  authUrl: 'https://keycloak.shlonak.exist.com.ph/realms/shlonak/protocol/openid-connect',
  clientId: 'web',
  fileUrl: 'https://shlonak.exist.com.ph'
};
